type AnalyticsEnvironment = 'development' | 'staging' | 'production';
type AnalyticsSource = 'public_web' | 'app_web';
type AnalyticsRole = 'anonymous' | 'patient' | 'therapist' | 'admin';

type AnalyticsUser = { id: number };

export type AnalyticsPageProps = {
  appEnv?: AnalyticsEnvironment;
  currentPatient?: AnalyticsUser;
  currentTherapist?: AnalyticsUser;
  currentAdmin?: AnalyticsUser;
};

export type AnalyticsContext = {
  environment: AnalyticsEnvironment;
  source: AnalyticsSource;
  role: AnalyticsRole;
  distinctId?: string;
};

export function getAnalyticsContext(
  pageProps: AnalyticsPageProps,
  url: string,
): AnalyticsContext {
  const environment =
    pageProps.appEnv || (import.meta.env.DEV ? 'development' : 'production');
  const isAppPath =
    url.startsWith('/patients') || url.startsWith('/therapists') || url.startsWith('/admin');
  const source: AnalyticsSource = isAppPath ? 'app_web' : 'public_web';

  if (url.startsWith('/admin')) {
    if (pageProps.currentAdmin?.id) {
      return {
        environment,
        source,
        role: 'admin',
        distinctId: `admin:${pageProps.currentAdmin.id}`,
      };
    }

    return { environment, source, role: 'anonymous' };
  }

  if (pageProps.currentTherapist?.id) {
    return {
      environment,
      source,
      role: 'therapist',
      distinctId: `therapist:${pageProps.currentTherapist.id}`,
    };
  }

  if (pageProps.currentPatient?.id) {
    return {
      environment,
      source,
      role: 'patient',
      distinctId: `patient:${pageProps.currentPatient.id}`,
    };
  }

  return { environment, source, role: 'anonymous' };
}
